module.exports = __webpack_public_path__ + "img/tars.f2f037b6.png";